import React, { Component } from 'react';
import { DatePicker, Select, Table } from 'antd';
import { map } from 'lodash';
import './OrderHistory.css';
import moment from 'moment';
import utils from '../../common/utils';
import consts from '../../consts';
import 'moment/locale/vi';
import 'moment/locale/en-il';
import Search from 'antd/lib/input/Search';
import _ from 'lodash';
import BigNumber from "bignumber.js";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { COLOR_BUY, COLOR_SELL } = consts;
const LIST_ORDER_STATUS = {
  0: 'Đang dừng',
  1: 'Đang chờ xử lý',
  2: 'Đã khớp',
  3: 'Đã hủy',
  4: 'Đang thực thi',
};

class OrderHistory extends Component {
  columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: 'Tài Khoản',
      width: 160,
      dataIndex: 'pubkey',
      key: 'pubkey',
      fixed: 'left',
      ellipsis: true,
    },
    {
      align: "center",
      title: 'Thời gian',
      width: 140,
      dataIndex: 'created_at',
      key: 'created_at',
      fixed: 'left',
      render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm'),
    },
    {
      align: "center",
      title: 'Loại lệnh',
      width: 100,
      dataIndex: 'type',
      key: 'type',
      fixed: 'left',
      render: (type) => utils.parseOrderType(type)
    },
    {
      align: "center",
      title: 'Loại giao dịch',
      width: 115,
      dataIndex: 'trade_type',
      key: '1',
      render: (tradeType) => <div
        style={{ color: utils.isBuyOrder(tradeType) ? COLOR_BUY : COLOR_SELL, }}
      >
        {utils.parseTradeType(tradeType)}
      </div>,
    },
    {
      align: 'center',
      title: 'Cặp',
      width: 120,
      dataIndex: 'pairs',
      key: '2'
    },
    {
      align: 'center',
      title: 'Giá',
      width: 150,
      dataIndex: 'price',
      key: '3',
      render: (amount) => utils.formatCurrency(amount)
    },
    {
      align: 'center',
      title: 'Số lượng',
      dataIndex: 'amount',
      width: 160,
      key: '4',
    },
    {
      align: 'center',
      title: 'Tổng',
      width: 160,
      dataIndex: 'total',
      key: '5',
    },
    {
      align: 'center',
      title: 'Đã khớp',
      dataIndex: 'executed_quantity',
      width: 160,
      key: '6',
    },
    {
      align: 'center',
      title: 'Còn lại',
      dataIndex: 'quantity',
      key: '7',
      width: 130,
      render: utils.formatCurrency
    },
    {
      align: "center",
      title: 'Trạng thái',
      width: 100,
      dataIndex: 'status',
      key: 'status',
      fixed: 'right',
      render: (status) => utils.parseOrderStatus(status),
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      orderHistory: [],
      orderPairs: [],
      currentPage: 1,
      totalCount: 0,
      isLoading: false,
      orderSearch: undefined,
    };

    this.filter = {
      coin: '',
      currency: '',
      order_type: -1,
      trade_type: -1,
      begin: '',
      end: '',
      status: -1,
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        // orderHistory: nextProps.orderHistory?.orderHistory || [],
        totalCount: nextProps.order?.totalCount,
      });
    }
  }

  showOptionPairs(orderPairs) {
    let result = null;
    if (orderPairs && orderPairs.length > 0) {
      result = orderPairs.map((item, index) => {
        return (
          <Option
            key={index}
            value={`${item.coin}/${item.currency}`}
          >
            {item.coin}/{item.currency}
          </Option>
        );
      });
    }
    return result;
  }

  onChangePairs = (value) => {
    let [coin, currency] = value.value.split('/');
    this.filter = {
      ...this.filter,
      coin,
      currency,
    };
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  handleChangeTradeType = (value) => {
    let tradeType = value.value;
    this.filter.trade_type = parseInt(tradeType);
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  handleChangeOrderType = (value) => {
    let orderType = value.value;
    this.filter.order_type = parseInt(orderType);
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  handleChangeOrderStatus = ({ value: status }) => {
    console.log(status, 'status');
    this.filter.status = status;
    this.setState({ currentPage: 1, });
    this.fetchData();
  };

  onChangeDate = (value) => {
    if (value !== null) {
      let start = value[0].startOf('day').toString();
      let dateEnd = value[1].endOf('day').toString();
      this.filter.begin = parseInt(moment(start).valueOf() / 1000);
      this.filter.end = parseInt(moment(dateEnd).valueOf() / 1000);
    } else {
      this.filter.begin = '';
      this.filter.end = '';
    }
    this.setState({ currentPage: 1, });
    this.fetchData();
  }

  handleSearchOrder = ({ currentTarget }) => {
    let orderSearch = undefined;
    if (_.isEmpty(`${currentTarget.value}`)) {
      this.setState({ orderSearch });
      return;
    }

    this.props.searchOrderByID({ order_id: currentTarget.value }, (orderSearch) => {
      const temp =  (new BigNumber(orderSearch.quantity)).plus( orderSearch.executed_quantity);
      this.setState({orderSearch: {
        ...orderSearch,
        pairs: `${orderSearch.coin}/${orderSearch.currency}`,
        amount: utils.formatCurrency(temp),
        total: utils.formatCurrency(temp.multipliedBy(orderSearch.price)),
        executed_quantity: utils.formatCurrency(orderSearch.executed_quantity),
      }});
    });
  }

  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    console.log(pos)
    this.setState({ isLoading: true });
    if (isRefresh) {
      this.filter = {
        ...this.filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      };
      this.setState({ currentPage: 1, });
    } else {
      this.filter = {
        ...this.filter,
        pos,
        count,
      };
    }
    this.props.onFetchFilterOrderHistoryAction(this.filter, this.updateTotalCount);
  };

  updateTotalCount = (totalCount) => this.setState({
    totalCount,
    isLoading: false
  });

  renderListOrderStatus = () => map(LIST_ORDER_STATUS, (value, key) => <Option
    value={key}>{value}</Option>);

  render() {
    const { orderSearch } = this.state;

    return (
      <div className="OrderTransaction">
        <div className="Transaction">
          <h3>Lịch sử lệnh</h3>
        </div>
        <div className="order-history">
          <div className="d-flex ">
            <div className="mr-medium">
              <span className="Transaction-Bag">Cặp</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 115 }}
                onChange={this.onChangePairs}
              >
                <Option value=""> Tất cả </Option>
                {this.showOptionPairs(this.props.coinSettings)}
              </Select>
            </div>
            <div className="mr-medium">
              <span className="Transaction-LoaiLenh">Loại giao dịch</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 90 }}
                onChange={this.handleChangeTradeType}
              >
                <Option value="-1">Tất cả </Option>
                <Option value="0">Mua </Option>
                <Option value="1">Bán </Option>
              </Select>
            </div>
            <div className="mr-medium">
              <span className="Transaction-LoaiLenh">Loại lệnh</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 140 }}
                onChange={this.handleChangeOrderType}
              >
                <Option value="-1">Tất cả </Option>
                <Option value="1">Thị trường </Option>
                <Option value="0">Giới hạn </Option>
                <Option value="2">Giới hạn dừng </Option>
              </Select>
            </div>
            <div className="mr-medium">
              <span className="Transaction-LoaiLenh">Trạng thái</span>
              <Select
                labelInValue
                defaultValue={{ value: 'Tất cả' }}
                style={{ width: 140 }}
                onChange={this.handleChangeOrderStatus}
              >
                <Option value="-1">Tất cả</Option>
                {this.renderListOrderStatus()}
              </Select>
            </div>
            <div className="DateStart">
              <span className="DateEnd-NKT"> Thời gian</span>
              <RangePicker
                locale={consts.LangDateVi}
                disabledDate={(current) => current && current > moment().endOf('day')}
                onChange={this.onChangeDate}
              />
            </div>
          </div>
          <div className="ml-medium">
          <span className="DateEnd-NKT"> Tìm kiếm</span>
            <Search onSearch={(value) => this.handleSearchOrder({ currentTarget: { value } })}
                    placeholder={"Tìm kiếm theo ID"} style={{width: 200}} allowClear
                    onPressEnter={this.handleSearchOrder} />
          </div>
        </div>
        <div className="Table">
          <Table
            columns={this.columns}
            dataSource={!!orderSearch ? [orderSearch] : this.props.order.orderHistory || []}
            scroll={{ x: 1600 }}
            bordered
            pagination={!!orderSearch ? false : {
              showQuickJumper: true,
              current: this.state.currentPage,
              showSizeChanger: false,
              onChange: (currentPage, pageSize) => {
                this.fetchData((currentPage - 1) * pageSize, pageSize);
                this.setState({
                  currentPage,
                  isLoading: true
                });
              },
              defaultPageSize: consts.DEFAULT_PAGE_SIZE,
              total: this.state.totalCount || 0,
              hideOnSinglePage: true,
            }}
            loading={this.state.isLoading}
          />
        </div>
      </div>
    );
  }
}

export default OrderHistory;
